import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import NotificationBell from './NotificationBell';

const studentLinks = [
  { to: '/student',              label: 'Panel',        icon: 'M3 12l9-9 9 9M5 10v10h14V10' },
  { to: '/student/profile',      label: 'Profilim',     icon: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0' },
  { to: '/student/applications', label: 'Başvurular',   icon: 'M9 5h6a2 2 0 012 2v12a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2zM9 9h6M9 13h6M9 17h4' },
  { to: '/student/portfolio',    label: 'Portföy',      icon: 'M12 2l9 4-9 4-9-4 9-4zM3 10l9 4 9-4M3 14l9 4 9-4' },
  { to: '/student/faq',          label: 'Rehber',       icon: 'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
  { to: '/student/2fa',          label: 'Güvenlik',     icon: 'M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z' },
];
const companyLinks = [
  { to: '/company',           label: 'Panel',      icon: 'M3 12l9-9 9 9M5 10v10h14V10' },
  { to: '/company/profile',   label: 'Profil',     icon: 'M3 21V7l9-4 9 4v14M9 21V12h6v9' },
  { to: '/company/positions', label: 'İlanlar',    icon: 'M9 5h6a2 2 0 012 2v12a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2zM9 9h6M9 13h6M9 17h4' },
  { to: '/company/students',  label: 'Havuz',      icon: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0' },
  { to: '/company/2fa',       label: 'Güvenlik',   icon: 'M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z' },
];
const adminLinks = [
  { to: '/admin',             label: 'Panel',      icon: 'M3 12l9-9 9 9M5 10v10h14V10' },
  { to: '/admin/companies',   label: 'Şirketler',  icon: 'M3 21V7l9-4 9 4v14M9 21V12h6v9' },
  { to: '/admin/students',    label: 'Öğrenciler', icon: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0' },
  { to: '/admin/app-stats',   label: 'İstatistik', icon: 'M4 19V5M4 19h16M8 15v-4M12 15V9M16 15v-7' },
  { to: '/admin/analytics',   label: 'Analitik',   icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
  { to: '/admin/audit-logs',  label: 'Audit Log',  icon: 'M9 5h6a2 2 0 012 2v12a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2zM9 9h6M9 13h6M9 17h4' },
  { to: '/admin/health',      label: 'Sistem',     icon: 'M3 12h4l3-9 4 18 3-9h4' },
  { to: '/admin/admins',      label: 'Adminler',   icon: 'M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z' },
  { to: '/admin/atama',       label: 'Atama',      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
  { to: '/admin/mesaj',       label: 'Mesaj',      icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
];

const roleLinks = { student: studentLinks, company: companyLinks, admin: adminLinks };
const roleLabels = { student: 'Öğrenci', company: 'Şirket', admin: 'Admin' };

// Mobil bottom nav için gösterilecek linkler (max 5)
const bottomNavLinks = {
  student: [studentLinks[0], studentLinks[1], studentLinks[2], studentLinks[4], studentLinks[5]],
  company: companyLinks.slice(0, 4),
  admin: adminLinks.slice(0, 5),
};

const Icon = ({ d, className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const Layout = ({ children }) => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const links = roleLinks[user?.role] || [];
  const bottomLinks = bottomNavLinks[user?.role] || [];
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const handleLogout = () => { logout(); navigate('/login'); };

  useEffect(() => {
    const onClick = (e) => { if (userMenuRef.current && !userMenuRef.current.contains(e.target)) setUserMenuOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <div className="px-5 pb-5 border-b border-ink-100">
        <div className="flex items-center gap-2">
          <img src="/favicon-icon.png" alt="" className="w-9 h-9 rounded-lg shadow-card object-contain bg-white p-0.5" />
          <div>
            <div className="font-bold text-ink-900 leading-tight text-sm">Türkiye Siber Güvenlik</div>
            <div className="text-[11px] text-ink-500 leading-tight">Kümelenmesi · Staj</div>
          </div>
        </div>
        <span className="mt-3 inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-brand-50 text-brand-700">{roleLabels[user?.role]}</span>
      </div>
      <nav className="flex-1 px-3 py-4 overflow-y-auto">
        {links.map(link => (
          <NavLink key={link.to} to={link.to} end={link.to.split('/').length <= 2}
            onClick={() => setSidebarOpen(false)}
            className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 text-sm font-medium transition-colors ${isActive ? 'bg-brand-50 text-brand-700' : 'text-ink-600 hover:bg-ink-50 hover:text-ink-900'}`}>
            <Icon d={link.icon} className="w-[18px] h-[18px]" />
            <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="px-5 py-4 border-t border-ink-100">
        <div className="text-xs text-ink-400 mb-2 truncate" title={user?.email}>{user?.email}</div>
        <button onClick={handleLogout} className="btn-secondary w-full justify-center">Çıkış Yap</button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex bg-ink-50">
      {/* Overlay */}
      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)} className="fixed inset-0 bg-ink-900/50 z-40 lg:hidden" />
      )}

      {/* Desktop sidebar */}
      <aside className="hidden lg:flex flex-col w-[240px] bg-white border-r border-ink-200 flex-shrink-0">
        <div className="py-5 flex-1 flex flex-col min-h-0"><SidebarContent /></div>
      </aside>

      {/* Mobile sidebar drawer */}
      <aside className={`lg:hidden fixed top-0 left-0 h-screen w-[260px] bg-white border-r border-ink-200 z-50 transform transition-transform duration-200 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} shadow-card-md`}>
        <div className="py-5 h-full flex flex-col"><SidebarContent /></div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        {/* Topbar */}
        <header className="sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-ink-200">
          <div className="flex items-center justify-between gap-3 px-4 sm:px-6 h-14">
            <button onClick={() => setSidebarOpen(o => !o)} aria-label="Menüyü aç"
              className="lg:hidden inline-flex items-center justify-center w-9 h-9 rounded-lg border border-ink-200 text-ink-600 hover:bg-ink-50">
              <Icon d="M4 6h16M4 12h16M4 18h16" />
            </button>
            <div className="flex-1" />
            <NotificationBell />
            <div className="relative" ref={userMenuRef}>
              <button onClick={() => setUserMenuOpen(o => !o)} className="flex items-center gap-2 pl-1 pr-2 py-1 rounded-lg hover:bg-ink-100">
                <div className="w-8 h-8 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center font-semibold text-sm">
                  {(user?.email || '?').charAt(0).toUpperCase()}
                </div>
                <Icon d="M6 9l6 6 6-6" className="w-4 h-4 text-ink-500 hidden sm:block" />
              </button>
              {userMenuOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white border border-ink-200 rounded-lg shadow-card-md py-1 z-50">
                  <div className="px-3 py-2 border-b border-ink-100">
                    <div className="text-xs text-ink-500">{roleLabels[user?.role]}</div>
                    <div className="text-sm font-medium text-ink-900 truncate">{user?.email}</div>
                  </div>
                  <button onClick={handleLogout} className="w-full text-left px-3 py-2 text-sm text-ink-700 hover:bg-ink-50">
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Main content — bottom padding for mobile nav */}
        <main className="flex-1 overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6 pb-24 lg:pb-6">
            {children}
          </div>
        </main>

        {/* Bottom navigation — mobile only */}
        {bottomLinks.length > 0 && (
          <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-ink-200 safe-area-pb">
            <div className={`grid h-16 ${bottomLinks.length <= 4 ? `grid-cols-${bottomLinks.length}` : 'grid-cols-5'}`}
              style={{ gridTemplateColumns: `repeat(${bottomLinks.length}, 1fr)` }}>
              {bottomLinks.map(link => (
                <NavLink key={link.to} to={link.to} end={link.to.split('/').length <= 2}
                  className={({ isActive }) =>
                    `flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors pt-1 ${isActive ? 'text-brand-700' : 'text-ink-400'}`
                  }>
                  {({ isActive }) => (
                    <>
                      <div className={`p-1 rounded-lg transition-colors ${isActive ? 'bg-brand-50' : ''}`}>
                        <Icon d={link.icon} className="w-5 h-5" />
                      </div>
                      <span className="truncate w-full text-center px-1">{link.label}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Layout;
